/* BABINES — socle JavaScript du thème.
   Données de la bande et du produit (injectées par snippets/babines-config.liquid), panier Shopify (API Ajax),
   panier latéral, menu mobile, mascottes, neige de pompons, bisou vers le panier, accordéons. */
(function () {
  'use strict';
  if (window.Babines) return;

  /* ---------- configuration ---------- */
  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('BabinesConfig').textContent) || {}; } catch (e) { CFG = {}; }
  var BAND = CFG.band || [];
  var SIZES = CFG.sizes || [];
  var ROUTES = CFG.routes || {};
  var PRODUCT = CFG.product || null;
  var FALLBACK = { id: '', nom: '', hex: '#F4978E', deep: '#C2564B', soft: '#FFF4E3', tuft: '#1C2140', line: '', hello: '', url: '', photo: '' };

  function reduced() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function fmt(cents) { return (Math.round(cents) / 100).toFixed(2).replace('.', ',') + ' ' + (CFG.currency || '€'); }
  function byId(id) { for (var i = 0; i < BAND.length; i++) if (BAND[i].id === id) return BAND[i]; return BAND[0] || FALLBACK; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function path(base, suffix) { return String(base || '').replace(/\/$/, '') + suffix; }

  /* ---------- variantes ---------- */
  function variantFor(colorId, size) {
    if (!PRODUCT) return null;
    for (var i = 0; i < PRODUCT.variants.length; i++) {
      var v = PRODUCT.variants[i];
      if (v.c === colorId && v.s === size) return v;
    }
    return null;
  }
  function variantById(id) {
    if (!PRODUCT) return null;
    for (var i = 0; i < PRODUCT.variants.length; i++) if (String(PRODUCT.variants[i].id) === String(id)) return PRODUCT.variants[i];
    return null;
  }
  function available(colorId, size) { var v = variantFor(colorId, size); return !!(v && v.a); }
  /* Prix affiché pour n monstres (lots de 3, puis 2, puis 1), comme dans la maquette. Le total réel vient toujours de Shopify. */
  function bundleTotal(n) {
    var P = CFG.prices || { solo: 4990, duo: 8990, bande: 12990 };
    if (!CFG.bundles) return n * P.solo;
    var t = 0, r = n;
    while (r >= 3) { t += P.bande; r -= 3; }
    if (r === 2) t += P.duo; else if (r === 1) t += P.solo;
    return t;
  }

  /* ---------- mascotte ---------- */
  function mascotSVG(color, tuft, label, track) {
    return '<svg viewBox="0 0 120 120" width="100%" height="100%" ' + (label ? 'role="img" aria-label="' + esc(label) + '"' : 'aria-hidden="true"') + ' data-mascot' + (track === false ? '' : ' data-track') + ' style="display:block;overflow:visible">' +
      '<g style="filter:url(#mfelt)">' +
      '<path data-m-tuft d="M38 40 L30 10 L46 30 L48 4 L58 28 L64 2 L70 28 L80 6 L80 32 L94 14 L86 42 Z" fill="' + esc(tuft) + '" stroke="#1C2140" style="stroke-width:3;stroke-linejoin:round"></path>' +
      '<path data-m-body d="M60 24 C88 24 104 44 104 70 C104 98 86 112 60 112 C34 112 16 98 16 70 C16 44 32 24 60 24 Z" fill="' + esc(color) + '" stroke="#1C2140" style="stroke-width:3.4"></path>' +
      '<ellipse data-m-eye cx="44" cy="50" rx="11" ry="11" fill="#fff" stroke="#1C2140" style="stroke-width:3"></ellipse>' +
      '<ellipse data-m-eye cx="76" cy="50" rx="11" ry="11" fill="#fff" stroke="#1C2140" style="stroke-width:3"></ellipse>' +
      '<circle data-m-pupil cx="44" cy="50" r="5.2" fill="#1C2140"></circle>' +
      '<circle data-m-pupil cx="76" cy="50" r="5.2" fill="#1C2140"></circle>' +
      '<path d="M14 76 C22 60 44 62 60 68 C76 62 98 60 106 76 C98 86 80 88 60 86 C40 88 22 86 14 76 Z" fill="#F4978E" stroke="#1C2140" style="stroke-width:3.2;stroke-linejoin:round"></path>' +
      '<path d="M20 80 C30 104 90 104 100 80 C86 88 34 88 20 80 Z" fill="#EC8379" stroke="#1C2140" style="stroke-width:3.2;stroke-linejoin:round"></path>' +
      '<path d="M30 80 C46 84 74 84 90 80" fill="none" stroke="#1C2140" style="stroke-width:3;stroke-linecap:round"></path>' +
      '<path d="M30 70 C36 66 44 66 50 68" fill="none" stroke="#fff" style="stroke-width:3;stroke-linecap:round;opacity:.55"></path>' +
      '</g></svg>';
  }
  function recolor(root, color, tuft) {
    qsa('[data-m-body]', root).forEach(function (el) { el.setAttribute('fill', color); });
    qsa('[data-m-tuft]', root).forEach(function (el) { el.setAttribute('fill', tuft); });
  }
  /* Les yeux suivent la souris, et clignent de temps en temps. */
  var tracked = [];
  var blinkTimers = new WeakMap();
  function initMascots(root) {
    if (reduced()) return;
    qsa('svg[data-mascot][data-track]', root).forEach(function (svg) {
      if (blinkTimers.has(svg)) return;
      tracked.push(svg);
      var eyes = qsa('[data-m-eye]', svg), pupils = qsa('[data-m-pupil]', svg);
      function blink() {
        if (!svg.isConnected) return;
        eyes.forEach(function (e) { e.setAttribute('ry', '1.5'); });
        pupils.forEach(function (p) { p.style.visibility = 'hidden'; });
        setTimeout(function () {
          eyes.forEach(function (e) { e.setAttribute('ry', '11'); });
          pupils.forEach(function (p) { p.style.visibility = ''; });
        }, 140);
        blinkTimers.set(svg, setTimeout(blink, 2600 + Math.random() * 3800));
      }
      blinkTimers.set(svg, setTimeout(blink, 1800));
    });
  }
  var moveQueued = false, lastMove = null;
  function onMouseMove(e) {
    lastMove = e;
    if (moveQueued) return;
    moveQueued = true;
    requestAnimationFrame(function () {
      moveQueued = false;
      tracked = tracked.filter(function (svg) { return svg.isConnected; });
      tracked.forEach(function (svg) {
        var r = svg.getBoundingClientRect();
        if (!r.width) return;
        var x = lastMove.clientX - (r.left + r.width / 2), y = lastMove.clientY - (r.top + r.height * 0.42);
        var d = Math.hypot(x, y) || 1, k = Math.min(1, d / 300);
        var dx = (x / d) * 4.4 * k, dy = (y / d) * 4.2 * k;
        var p = svg.querySelectorAll('[data-m-pupil]');
        if (p[0]) { p[0].setAttribute('cx', 44 + dx); p[0].setAttribute('cy', 50 + dy); }
        if (p[1]) { p[1].setAttribute('cx', 76 + dx); p[1].setAttribute('cy', 50 + dy); }
      });
    });
  }

  /* ---------- bisou vers le panier ---------- */
  var LIPS = '<svg viewBox="0 0 64 40" width="44" height="28"><path d="M4 18 C14 2 26 6 32 12 C38 6 50 2 60 18 C50 24 40 22 32 22 C24 22 14 24 4 18Z" fill="#F4978E" stroke="#1C2140" stroke-width="2.5" stroke-linejoin="round"/><path d="M6 20 C18 38 46 38 58 20 C46 26 18 26 6 20Z" fill="#E9776D" stroke="#1C2140" stroke-width="2.5" stroke-linejoin="round"/></svg>';
  function kiss(fromEl, cb) {
    var target = document.querySelector('[data-cart-icon]');
    if (!target || !fromEl || reduced() || !document.body.animate) { cb && cb(); return; }
    var a = fromEl.getBoundingClientRect(), b = target.getBoundingClientRect();
    var el = document.createElement('div');
    el.innerHTML = LIPS;
    el.setAttribute('aria-hidden', 'true');
    el.style.cssText = 'position:fixed;left:0;top:0;z-index:9999;pointer-events:none';
    document.body.appendChild(el);
    var x0 = a.left + a.width / 2 - 22, y0 = a.top + a.height / 2 - 14;
    var x1 = b.left + b.width / 2 - 22, y1 = b.top + b.height / 2 - 14;
    var mx = (x0 + x1) / 2 - 80, my = Math.min(y0, y1) - 160;
    var frames = [];
    for (var i = 0; i <= 12; i++) {
      var t = i / 12, u = 1 - t;
      var x = u * u * x0 + 2 * u * t * mx + t * t * x1, y = u * u * y0 + 2 * u * t * my + t * t * y1;
      var s = i === 0 ? 0.4 : i < 3 ? 1.4 : 1.1 - t * 0.6;
      frames.push({ transform: 'translate(' + x + 'px,' + y + 'px) scale(' + s + ') rotate(' + (t * 40 - 20).toFixed(0) + 'deg)', opacity: i === 12 ? 0.2 : 1 });
    }
    el.animate(frames, { duration: 900, easing: 'cubic-bezier(.45,.05,.4,1)' }).onfinish = function () {
      el.remove();
      target.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.3,0.8)' }, { transform: 'scale(0.9,1.15)' }, { transform: 'scale(1)' }], { duration: 420 });
      cb && cb();
    };
  }

  /* ---------- pompons : sprites + neige ---------- */
  var spriteCache = {};
  function shade(hex, k) {
    var n = parseInt(hex.slice(1), 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255;
    r = Math.round(Math.min(255, Math.max(0, r * k))); g = Math.round(Math.min(255, Math.max(0, g * k))); b = Math.round(Math.min(255, Math.max(0, b * k)));
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }
  function sprite(hex, R) {
    var key = hex + R; if (spriteCache[key]) return spriteCache[key];
    var S = R * 2 + 8, c = document.createElement('canvas'); c.width = c.height = S * 2;
    var x = c.getContext('2d'); x.scale(2, 2); var cx = S / 2;
    x.fillStyle = shade(hex, 0.82); x.beginPath(); x.arc(cx, cx, R * 0.92, 0, 7); x.fill();
    x.lineCap = 'round';
    for (var i = 0; i < 90; i++) {
      var ang = Math.random() * Math.PI * 2, r0 = Math.random() * R * 0.7, len = R * (0.25 + Math.random() * 0.45);
      var light = Math.sin(ang - 3.9) * 0.5 + 0.5;
      x.strokeStyle = shade(hex, 0.8 + light * 0.32); x.lineWidth = 1.1 + Math.random() * 1.2;
      x.beginPath(); x.moveTo(cx + Math.cos(ang) * r0, cx + Math.sin(ang) * r0);
      x.lineTo(cx + Math.cos(ang) * Math.min(R + 2, r0 + len), cx + Math.sin(ang) * Math.min(R + 2, r0 + len)); x.stroke();
    }
    var g = x.createRadialGradient(cx - R * 0.35, cx - R * 0.4, 0, cx, cx, R);
    g.addColorStop(0, 'rgba(255,255,255,.45)'); g.addColorStop(0.5, 'rgba(255,255,255,0)'); g.addColorStop(1, 'rgba(28,33,64,.12)');
    x.fillStyle = g; x.beginPath(); x.arc(cx, cx, R, 0, 7); x.fill();
    return (spriteCache[key] = { c: c, S: S });
  }
  function normHex(h) {
    h = String(h || '').trim();
    if (/^#[0-9a-f]{3}$/i.test(h)) h = '#' + h[1] + h[1] + h[2] + h[2] + h[3] + h[3];
    return /^#[0-9a-f]{6}$/i.test(h) ? h : '#F4978E';
  }
  function snow(canvas, opts) {
    var o = { density: 26, colors: BAND.length ? BAND.map(function (b) { return b.hex; }) : ['#F4978E', '#9DD0F0', '#FFFFFF'], min: 5, max: 13, speed: 1 };
    for (var k in (opts || {})) o[k] = opts[k];
    var ctx = canvas.getContext('2d'), W = 0, H = 0, raf = 0, alive = true, speed = o.speed, melt = 0, colors = o.colors.map(normHex);
    var flakes = [];
    var dpr = function () { return window.devicePixelRatio || 1; };
    function mk(any) {
      var R = o.min + Math.random() * (o.max - o.min);
      return { x: Math.random() * W, y: any ? Math.random() * H : -R * 2, R: R, vy: 0.25 + Math.random() * 0.45 + R / 40, ph: Math.random() * 6.28, sw: 0.3 + Math.random() * 0.6, col: colors[(Math.random() * colors.length) | 0], rot: Math.random() * 6 };
    }
    function resize() {
      var r = canvas.getBoundingClientRect(); W = r.width; H = r.height;
      canvas.width = W * dpr(); canvas.height = H * dpr(); ctx.setTransform(dpr(), 0, 0, dpr(), 0, 0);
      var n = Math.round(o.density * Math.max(0.45, W / 1440));
      while (flakes.length < n) flakes.push(mk(true)); flakes.length = n;
    }
    function draw(step) {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        if (step) { f.y += f.vy * speed; f.ph += 0.012 * Math.max(speed, 0.2); f.x += Math.sin(f.ph) * f.sw * Math.max(speed, 0.2); }
        if (f.y > H + f.R * 2) { var nf = mk(false); nf.x = Math.random() * W; flakes[i] = f = nf; }
        var s = sprite(f.col, Math.round(f.R)), sc = 1 - melt * 0.85;
        if (sc <= 0.05) continue;
        ctx.globalAlpha = 1 - melt * 0.9;
        ctx.save(); ctx.translate(f.x, f.y); ctx.scale(sc, sc * (1 - melt * 0.35)); ctx.drawImage(s.c, -s.S / 2, -s.S / 2, s.S, s.S); ctx.restore();
      }
      ctx.globalAlpha = 1;
    }
    function loop() { if (!alive) return; draw(true); raf = requestAnimationFrame(loop); }
    resize();
    var ro = new ResizeObserver(function () { resize(); if (reduced()) draw(false); }); ro.observe(canvas);
    var io = new IntersectionObserver(function (es) {
      var v = es[0].isIntersecting;
      if (v && !raf && !reduced()) { alive = true; loop(); } else if (!v) { cancelAnimationFrame(raf); raf = 0; }
    });
    if (reduced()) draw(false); else io.observe(canvas);
    return {
      setSpeed: function (v) { speed = v; if (reduced()) draw(false); },
      setMelt: function (v) { melt = v; if (reduced()) draw(false); },
      setColors: function (c) { colors = c.map(normHex); flakes.forEach(function (f) { f.col = colors[(Math.random() * colors.length) | 0]; }); if (reduced()) draw(false); },
      stop: function () { alive = false; cancelAnimationFrame(raf); ro.disconnect(); io.disconnect(); }
    };
  }
  function initSnow(root) {
    qsa('canvas[data-snow]', root).forEach(function (c) {
      if (c._snow) return;
      var o = {}; try { o = JSON.parse(c.getAttribute('data-snow') || '{}'); } catch (e) {}
      c._snow = snow(c, o);
    });
  }

  /* ---------- filtres SVG (peluche, givre, feutre) + grain, une fois par page ---------- */
  function defs() {
    if (document.getElementById('babines-defs')) return;
    var d = document.createElement('div'); d.id = 'babines-defs';
    d.innerHTML = '<svg width="0" height="0" style="position:absolute" aria-hidden="true"><defs>' +
      '<filter id="fluff" x="-10%" y="-10%" width="120%" height="120%"><feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" seed="3"/><feDisplacementMap in="SourceGraphic" scale="5" xChannelSelector="R" yChannelSelector="G"/></filter>' +
      '<filter id="fluffbig" x="-10%" y="-10%" width="120%" height="120%"><feTurbulence type="fractalNoise" baseFrequency="0.7" numOctaves="2" seed="8"/><feDisplacementMap in="SourceGraphic" scale="9" xChannelSelector="R" yChannelSelector="G"/></filter>' +
      '<filter id="frost" x="-5%" y="-5%" width="110%" height="110%"><feTurbulence type="fractalNoise" baseFrequency="0.035 0.06" numOctaves="3" seed="11"/><feDisplacementMap in="SourceGraphic" scale="22" xChannelSelector="R" yChannelSelector="G"/></filter>' +
      '<filter id="felt" x="-5%" y="-5%" width="110%" height="110%"><feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="2" seed="5"/><feDisplacementMap in="SourceGraphic" scale="2.4" xChannelSelector="R" yChannelSelector="G"/></filter>' +
      '<filter id="mfelt" x="-5%" y="-5%" width="110%" height="110%"><feTurbulence type="fractalNoise" baseFrequency="0.05" numOctaves="2" seed="5"/><feDisplacementMap in="SourceGraphic" scale="2.2" xChannelSelector="R" yChannelSelector="G"/></filter>' +
      '</defs></svg>';
    document.body.appendChild(d);
    var g = document.createElement('div'); g.setAttribute('aria-hidden', 'true');
    g.style.cssText = "position:fixed;inset:0;pointer-events:none;z-index:9998;opacity:0.07;mix-blend-mode:multiply;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='180'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.85' numOctaves='3' stitchTiles='stitch'/%3E%3CfeColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0'/%3E%3C/filter%3E%3Crect width='180' height='180' filter='url(%23n)'/%3E%3C/svg%3E\")";
    document.body.appendChild(g);
  }

  /* ---------- panier Shopify (API Ajax) ---------- */
  var cartState = null;
  function jsonFetch(url, body) {
    var opt = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (body) { opt.method = 'POST'; opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
    return fetch(url, opt).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var err = new Error(j.description || j.message || 'Le panier ne répond pas. Réessaie dans un instant.'); err.status = r.status; throw err; }
        return j;
      });
    });
  }
  function setCart(c) { cartState = c; window.dispatchEvent(new CustomEvent('babines:cart', { detail: c })); return c; }
  function refreshCart() { return jsonFetch(path(ROUTES.cart || '/cart', '.js')).then(setCart); }
  function cartError(msg) { window.dispatchEvent(new CustomEvent('babines:cart-error', { detail: msg })); }
  /* list : [{ id: 'myrtille', size: 'M', qty: 1 }] ou [{ variant: 123, qty: 1 }] */
  function addToCart(list, originEl, opts) {
    list = Array.isArray(list) ? list : [list];
    var byVariant = {}, order = [], missing = null;
    list.forEach(function (it) {
      var vid = it.variant || null;
      if (!vid) { var v = variantFor(it.id, it.size); if (!v) { missing = it; return; } vid = v.id; }
      if (!byVariant[vid]) { byVariant[vid] = 0; order.push(vid); }
      byVariant[vid] += it.qty || 1;
    });
    if (missing || !order.length) {
      var m = PRODUCT ? 'Ce monstre n’existe pas dans cette taille.' : 'Le produit n’est pas encore relié au thème (Réglages du thème > Produit et prix).';
      cartError(m); openCart(); return Promise.reject(new Error(m));
    }
    var items = order.map(function (vid) { return { id: vid, quantity: byVariant[vid] }; });
    var animDone = new Promise(function (res) { if (originEl) kiss(originEl, res); else res(); });
    var req = jsonFetch(path(ROUTES.cartAdd || '/cart/add', '.js'), { items: items }).then(refreshCart);
    return Promise.all([req, animDone]).then(function (r) {
      if (!(opts && opts.silent)) openCart();
      return r[0];
    }).catch(function (err) {
      cartError(err.message); openCart(); refreshCart().catch(function () {});
      throw err;
    });
  }
  function changeLine(key, qty) {
    return jsonFetch(path(ROUTES.cartChange || '/cart/change', '.js'), { id: key, quantity: qty }).then(setCart).catch(function (err) {
      cartError(err.message); return refreshCart();
    });
  }

  /* ---------- panier latéral ---------- */
  var drawer, overlay, lastFocus = null;
  function itemInfo(it) {
    var v = variantById(it.variant_id), b = null, size = '';
    if (v) { b = byId(v.c); size = v.s; }
    else {
      (it.options_with_values || []).forEach(function (o) {
        BAND.forEach(function (x) { if (x.nom.toLowerCase() === String(o.value).toLowerCase()) b = x; });
      });
    }
    return { b: b, size: size };
  }
  function renderCart(cart) {
    if (!drawer || !cart) return;
    var n = cart.item_count || 0, q = CFG.freeShipQty || 2;
    var badge = document.querySelector('[data-cart-badge]'), count = document.querySelector('[data-cart-count]'), icon = document.querySelector('[data-cart-icon]');
    if (badge) badge.hidden = n === 0;
    if (count) count.textContent = n;
    if (icon) icon.setAttribute('aria-label', n ? 'Panier, ' + n + ' monstre' + (n > 1 ? 's' : '') : 'Panier vide');
    var left = q - n;
    drawer.querySelector('[data-cart-shipmsg]').textContent = q <= 1 ? 'Livraison offerte. Tes monstres voyagent gratos.' : n === 0 ? 'La livraison est offerte dès ' + q + ' monstres.' : left === 1 ? 'Plus qu’un monstre et la livraison est offerte.' : left > 1 ? 'Plus que ' + left + ' monstres et la livraison est offerte.' : 'Livraison offerte. Tes monstres voyagent gratos.';
    var pct = (q <= 1 ? 100 : Math.min(100, (n / q) * 100)) + '%';
    drawer.querySelector('[data-cart-shipbar]').style.width = pct;
    drawer.querySelector('[data-cart-shipthumb]').style.left = pct;
    drawer.querySelector('[data-cart-empty]').hidden = n !== 0;
    var html = '', last = null, inCart = {};
    (cart.items || []).forEach(function (it) {
      var info = itemInfo(it), b = info.b || FALLBACK;
      if (info.b) { inCart[info.b.id] = true; last = { id: info.b.id, size: info.size }; }
      var title = info.b ? esc(it.product_title) + ' — ' + esc(info.b.nom) : esc(it.title);
      var sub = info.b && info.size ? 'Taille ' + esc(info.size) : '';
      html += '<div style="display:grid;grid-template-columns:72px 1fr auto;gap:14px;align-items:center;padding:14px 0;border-bottom:2px dashed #EADBC3">' +
        '<div style="width:72px;height:72px;border-radius:50%;background:' + esc(b.soft) + ';display:grid;place-items:center"><div style="width:56px;height:56px">' + mascotSVG(b.hex, b.tuft, info.b ? b.nom : '', false) + '</div></div>' +
        '<div><div style="font-weight:700;font-size:15px">' + title + '</div>' +
        (sub ? '<div style="font-size:13px;color:#3A3F5C;margin-top:2px">' + sub + '</div>' : '') +
        '<div style="display:flex;align-items:center;gap:6px;margin-top:8px">' +
        '<button type="button" data-line="' + esc(it.key) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Retirer un" style="width:32px;height:32px;border-radius:50%;border:2px solid #1C2140;background:#fff;cursor:pointer;font-size:18px;line-height:1;color:#1C2140">−</button>' +
        '<span style="min-width:22px;text-align:center;font-weight:700">' + it.quantity + '</span>' +
        '<button type="button" data-line="' + esc(it.key) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Ajouter un" style="width:32px;height:32px;border-radius:50%;border:2px solid #1C2140;background:#fff;cursor:pointer;font-size:18px;line-height:1;color:#1C2140">+</button>' +
        '</div></div>' +
        '<div style="font-weight:700;font-size:15px">' + fmt(it.original_line_price) + '</div></div>';
    });
    drawer.querySelector('[data-cart-items]').innerHTML = html;
    /* « Il a besoin d'un copain » : autres coloris disponibles dans la même taille */
    var quick = drawer.querySelector('[data-cart-quick]'), qlist = drawer.querySelector('[data-cart-quick-list]');
    var options = (n === 1 && last) ? BAND.filter(function (b) { return !inCart[b.id] && available(b.id, last.size); }).slice(0, 4) : [];
    quick.hidden = options.length === 0;
    qlist.innerHTML = options.map(function (b) {
      return '<button type="button" class="sh-quick" data-quick-add="' + esc(b.id) + '" data-size="' + esc(last.size) + '" aria-label="Ajouter ' + esc(b.nom) + '" title="' + esc(b.nom) + '" style="width:52px;height:52px;border:0;border-radius:50%;background:' + esc(b.soft) + ';cursor:pointer;display:grid;place-items:center;transition:transform .2s"><div style="width:42px;height:42px;pointer-events:none">' + mascotSVG(b.hex, b.tuft, '', false) + '</div></button>';
    }).join('');
    var footer = drawer.querySelector('[data-cart-footer]');
    footer.hidden = n === 0;
    var saving = cart.total_discount || 0;
    drawer.querySelector('[data-cart-saving-row]').hidden = saving <= 0;
    drawer.querySelector('[data-cart-saving]').textContent = '−' + fmt(saving);
    drawer.querySelector('[data-cart-shiplabel]').textContent = n >= q ? 'Offerte' : (CFG.shipLabel || '');
    drawer.querySelector('[data-cart-total]').textContent = fmt(cart.total_price || 0);
  }
  function openCart() {
    if (!drawer) return;
    if (drawer.hidden) lastFocus = document.activeElement;
    drawer.hidden = false; overlay.hidden = false;
    if (cartState) renderCart(cartState);
    var c = drawer.querySelector('[data-cart-close]'); if (c) c.focus({ preventScroll: true });
  }
  function closeCart() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true; overlay.hidden = true;
    var err = drawer.querySelector('[data-cart-error]'); if (err) err.hidden = true;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function initHeader() {
    drawer = document.querySelector('[data-cart-drawer]'); overlay = document.querySelector('[data-cart-overlay]');
    var menu = document.querySelector('[data-menu]'), menuOpener = null;
    function closeMenu() { if (menu && !menu.hidden) { menu.hidden = true; if (menuOpener) menuOpener.focus({ preventScroll: true }); } }
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : e.target.parentElement;
      if (!t) return;
      var el;
      if ((el = t.closest('[data-cart-open]'))) { if (!drawer) return; e.preventDefault(); openCart(); refreshCart().catch(function () {}); return; }
      if (t.closest('[data-cart-close]') || t.closest('[data-cart-overlay]')) { closeCart(); return; }
      if ((el = t.closest('[data-menu-open]'))) { if (menu) { menuOpener = el; menu.hidden = false; var c = menu.querySelector('[data-menu-close]'); if (c) c.focus({ preventScroll: true }); } return; }
      if (t.closest('[data-menu-close]')) { closeMenu(); return; }
      if ((el = t.closest('[data-line]'))) { el.disabled = true; changeLine(el.getAttribute('data-line'), Math.max(0, parseInt(el.getAttribute('data-qty'), 10) || 0)); return; }
      if ((el = t.closest('[data-quick-add]'))) { addToCart({ id: el.getAttribute('data-quick-add'), size: el.getAttribute('data-size') }, el, { silent: true }).catch(function () {}); return; }
      if ((el = t.closest('[data-add-item]'))) {
        if (el.hasAttribute('data-soldout')) return;
        addToCart({ id: el.getAttribute('data-color'), size: el.getAttribute('data-size') }, el).catch(function () {});
        var card = el.closest('[data-band-card]'); if (card) toggleQuick(card, false);
        return;
      }
      if ((el = t.closest('[data-quick-toggle]'))) {
        var cardEl = el.closest('[data-band-card]');
        var isOpen = el.getAttribute('aria-expanded') === 'true';
        qsa('[data-band-card]').forEach(function (c) { toggleQuick(c, false); });
        toggleQuick(cardEl, !isOpen);
        return;
      }
      if ((el = t.closest('[data-acc-btn]'))) { toggleAcc(el); return; }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeMenu(); window.dispatchEvent(new Event('babines:escape')); } });
    window.addEventListener('babines:cart', function (e) { renderCart(e.detail); });
    window.addEventListener('babines:cart-error', function (e) {
      if (!drawer) return;
      var el = drawer.querySelector('[data-cart-error]'); if (el) { el.textContent = e.detail; el.hidden = false; }
    });
    /* Retour arrière du navigateur : le panier a pu changer */
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart().catch(function () {}); });
  }
  function toggleQuick(card, open) {
    if (!card) return;
    var btn = card.querySelector('[data-quick-toggle]'), panel = card.querySelector('[data-quick-sizes]');
    if (!btn || !panel) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = open ? 'Fermer' : 'Ajout rapide';
    panel.hidden = !open;
  }
  /* Tailles épuisées sur les boutons d'ajout rapide */
  function markStock(root) {
    if (!PRODUCT) return;
    qsa('[data-add-item]', root).forEach(function (el) {
      var ok = available(el.getAttribute('data-color'), el.getAttribute('data-size'));
      if (ok) { el.removeAttribute('data-soldout'); el.removeAttribute('aria-disabled'); el.style.opacity = ''; el.style.textDecoration = ''; }
      else { el.setAttribute('data-soldout', ''); el.setAttribute('aria-disabled', 'true'); el.style.opacity = '.45'; el.style.textDecoration = 'line-through'; el.title = 'Épuisé'; }
    });
  }

  /* ---------- accordéons : un seul volet ouvert par groupe [data-acc] ---------- */
  function toggleAcc(btn) {
    var root = btn.closest('[data-acc]') || document;
    var open = btn.getAttribute('aria-expanded') === 'true';
    qsa('[data-acc-btn]', root).forEach(function (b) {
      if (b === btn) return;
      b.setAttribute('aria-expanded', 'false');
      var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = true;
    });
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    var panel = document.getElementById(btn.getAttribute('aria-controls')); if (panel) panel.hidden = open;
  }

  /* ---------- bandeau défilant ---------- */
  function initMarquee(root) {
    qsa('[data-marquee]', root).forEach(function (m) {
      if (m._mq || reduced() || !m.animate) return;
      m._mq = m.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-50%)' }], { duration: 38000, iterations: Infinity });
    });
  }

  /* ---------- initialisation ---------- */
  var pageInits = [];
  function initAll(root) {
    initSnow(root); initMascots(root); initMarquee(root); markStock(root);
    pageInits.forEach(function (fn) { try { fn(root || document); } catch (e) { if (window.console) console.error(e); } });
  }
  window.Babines = {
    CFG: CFG, BAND: BAND, SIZES: SIZES, PRODUCT: PRODUCT, fmt: fmt, byId: byId, esc: esc, qsa: qsa, reduced: reduced,
    variantFor: variantFor, variantById: variantById, available: available, bundleTotal: bundleTotal,
    mascotSVG: mascotSVG, recolor: recolor, initMascots: initMascots, kiss: kiss, snow: snow,
    cart: { add: addToCart, change: changeLine, refresh: refreshCart, open: openCart, close: closeCart, get: function () { return cartState; } },
    register: function (fn) { pageInits.push(fn); if (booted) { try { fn(document); } catch (e) { if (window.console) console.error(e); } } }
  };
  var booted = false;
  function boot() {
    if (booted) return;
    booted = true;
    defs();
    initHeader();
    window.addEventListener('mousemove', onMouseMove, { passive: true });
    initAll(document);
    refreshCart().catch(function () {});
    /* Éditeur de thème Shopify : réinitialise la section rechargée */
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  }
  /* Les deux scripts sont chargés en « defer » : babines-pages.js s'enregistre avant DOMContentLoaded. */
  if (document.readyState === 'complete') boot();
  else { document.addEventListener('DOMContentLoaded', boot); window.addEventListener('load', boot); }
})();
